import styled from 'styled-components';
import { pxToRem, fontWeight, vars, media } from '$util/theme';
import { getBreakpoint } from '$util/theme/breakpoints';
import TopBackground from '$layout/partials/TopBackground';

export const SubTitle = styled.h2`
  margin-top: 20px;
  font-size: ${pxToRem(18)};
  font-weight: ${vars.regular};
`;

export default styled(TopBackground)`
  &.AdvantagesDiv {
    margin-bottom: 0 !important;
  }

  .top-wrapper {
    padding: 128px 0 32px 0;
    margin-bottom: 30px;
    text-align: center;

    .title {
      font-weight: ${fontWeight.light};
      max-width: 52%;
      margin: auto;
      @media (min-width: ${getBreakpoint('xs')}) and (max-width: ${getBreakpoint('md')}) {
        max-width: 100%;
        padding: 0 10px;
      }
      @media (min-width: ${getBreakpoint('lg')}) and (max-width: ${getBreakpoint('xl')}) {
        max-width: 75%;
      }
    }
    .subtitle {
      font-size: 1.6em;
      font-weight: ${fontWeight.light};
      @media (min-width: ${getBreakpoint('xs')}) and (max-width: ${getBreakpoint('sm')}) {
        display: none;
      }
    }

    @media (max-width: ${getBreakpoint('md')}) {
      padding: 24px 16px;
    }

    .title {
      margin-bottom: 0;
      width: 100%;

      @media (max-width: ${getBreakpoint('md')}) {
        font-size: 1.6rem;
      }

      @media (min-width: ${getBreakpoint('md')}) and (max-width: ${getBreakpoint('lg')}) {
        font-size: 2.2rem;
        max-width: 73%;
      }

      .break {
        @media (min-width: ${getBreakpoint('md')}) {
          display: block;
        }
      }

      .light {
        font-weight: ${fontWeight.light};
      }
    }

    .vrm-lookup {
      margin: 20px auto 0 auto;
      @media (min-width: ${getBreakpoint('lg')}) {
        margin: 34px auto 0 auto;
      }
      .react-autosuggest__suggestions-container {
        width: 100%;
      }
    }

    .postcode {
      text-align: left;
    }

    .mobile-services-list-wrapper {
      display: none;

      @media (max-width: ${getBreakpoint('md')}) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
        margin-top: 16px;
      }
    }
  }

  .middle-wrapper {
    @media (max-width: ${getBreakpoint('md')}) {
      display: none;
      padding: 15px;
    }

    display: flex;
    justify-content: center;

    > div {
      margin: 0 34px 0 0;
      display: flex;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  .bottom-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    .AdvantagesDiv {
      overflow: visible;
      padding-top: 20px;
      margin-bottom: 0;

      .-nobold {
        font-weight: normal;
      }
      @media (min-width: ${getBreakpoint('lg')}) {
        .card-2 {
          width: auto;
        }
      }
      @media (max-width: ${getBreakpoint('sm')}) {
        > .ant-row {
          margin: 0 !important;
        }
      }
    }
    .part-of-renault {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      ${media.up('md')} {
        margin-top: 0px;
      }
      &.with-path {
        margin-top: 0;
        margin-bottom: 40px;
        ${media.up('md')} {
          margin-top: 20px !important;
        }
      }
    }
    .goto-scroll {
      margin-top: 22px;
      cursor: pointer;

      .img-svg {
        width: 10px;
        height: 7px;
      }
    }
    @media (max-width: ${getBreakpoint('sm')}) {
      > .AdvantagesDiv {
        .ant-col > .card-2 {
          display: flex;
          align-items: center;
          > img {
            padding-right: 20px;
          }
        }
      }
    }
  }
`;
